<template>
  <div class="comments-window__header d-flex justify-content-between align-content-center">
    <div class="comments-window__header-text">
      <span>
        {{ $t('Notifications') }}
      </span>
      <component :is="($router ? 'router-link': 'a')" href="/develop/notifications" to="/develop/notifications"
                 class="mx-2">
        <app-icon-with-action
          :title="$t('Go to Notification Center')"
          v-b-tooltip:hover
          @click="onCloseClick"
        >
          <i class="fal fa-external-link-square text-secondary"/>
        </app-icon-with-action>
      </component>
    </div>
    <div class="comments-window__header-close-button">
      <app-icon-with-action
        :title="$t('Close Notifications Window')"
        v-b-tooltip:hover
        @click="onCloseClick"
      >
        <i class="fal fa-times-circle"></i>
      </app-icon-with-action>
    </div>
  </div>
</template>

<script>
import AppIconWithAction from '@/components/htmlHelpers/AppIconWithAction'
import BaseComponent from '@/components/commentsNew/BaseComponent'

export default {
  name: 'NotificationsWindowHeader',
  extends: BaseComponent,
  components: { AppIconWithAction },
  methods: {
    onCloseClick () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";

.comments-window__header {
  padding: 16px;
  background-color: $gray-200;

  &-text {
    font-weight: bold;
    font-size: 20px;
    color: $gray-600;
    line-height: 1;
  }

  &-close-button {
    i {
      cursor: pointer;
      color: $secondary;
      font-size: 20px;
    }
  }
}
</style>
